import { isPlainObject } from 'lodash';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

export default (
  type = 'success',
  titleMessage = 'Error',
  contentMessage = 'Something went wrong!',
  timeClose = 4000,
  func = () => {}
) => {
  console.log({ contentMessage, titleMessage });
  //* legacy code -> this is trick
  if (isPlainObject(contentMessage) && contentMessage.ignoreShowMessage) {
    return;
  }

  switch (type) {
    case 'info':
      NotificationManager.info(titleMessage, contentMessage, timeClose, func);
      break;
    case 'success':
      NotificationManager.success(titleMessage, contentMessage, timeClose, func);
      break;
    case 'warning':
      NotificationManager.warning(titleMessage, contentMessage, timeClose, func);
      break;
    case 'error':
      NotificationManager.error(titleMessage, contentMessage, timeClose, func);
      break;
    default:
      break;
  }
};
